(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-rates"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.js-search-input');
  if (!searchInput) return;

  const rateCards = document.querySelectorAll('.js-rate-card');

  searchInput.addEventListener('input', function(e) {
    const searchTerm = e.target.value.toLowerCase();

    rateCards.forEach(card => {
      const location = card.querySelector('.rate-location').textContent.toLowerCase();
      card.style.display = location.includes(searchTerm) ? 'flex' : 'none';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
